import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeftSidebarComponent } from './left-sidebar/left-sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbAlertModule, NgbCollapseModule, NgbDropdownModule, NgbNavModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient } from '@angular/common/http';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TimesInfoTopBarModule } from 'src/app/pages/projects/board/times-info-top-bar/times-info-top-bar.module';
import { BoardMainScreenService } from 'src/app/pages/projects/board/board-main-screen/board-main-screen.service';
import { TaskViewModalModule } from 'src/app/pages/projects/board/task-view-modal/task-view-modal.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/layout/', '.json');
}

@NgModule({
  declarations: [
    LeftSidebarComponent,
    TopbarComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    FormsModule,
    NgbAlertModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    NgbNavModule,
    SimplebarAngularModule,
    ClickOutsideModule,
    PipesModule,
    OverlayPanelModule,
    TimesInfoTopBarModule,
    TaskViewModalModule
  ],
  exports: [
    LeftSidebarComponent,
//    TopbarComponent,
    FooterComponent
  ],
})
export class LayoutSharedModule { 
}
